import { useQuery } from '@apollo/client';
import {
  BookmarkIdsQuery,
  BookmarkIdsQueryVariables
} from '../graphql/graphql';
import { getBookmarkIds } from '../api/queries';

export const useBookmarks = () => {
  const { data } = useQuery<BookmarkIdsQuery, BookmarkIdsQueryVariables>(
    getBookmarkIds
  );

  const isBookmarked = (id: string): boolean =>
    data?.bookmarks?.some(bookmark => bookmark.item.id === id) ?? false;

  return { bookmarkIds: data?.bookmarks || [], isBookmarked };
};
